<div class="pb-4 ps-2 ps-sm-2 ps-md-4 ps-lg-4 ps-xl-4 ps-xxl-4 pe-2 pe-sm-2 pe-md-4 pe-lg-4 pe-xl-4 pe-xxl-4">
    <div class="justify-content-center text-center w-100 p-5">
        <h1><i class="d-none d-lg-block actionIcon bi bi-heartbreak"></i></h1>
        <ng-container *ngIf="unfilteredRequestCount != filteredRequestCount">
            <p translate="dashboard.FilteredDashboard"></p>
        </ng-container>
        <ng-container *ngIf="unfilteredRequestCount == filteredRequestCount">
            <p translate="dashboard.EmptyDashboard"></p>
            <app-new-request-picker class="justify-content-center center w-100"></app-new-request-picker>
        </ng-container>
    </div>
</div>